import { render, staticRenderFns } from "./BordereauxDocuments.vue?vue&type=template&id=1a9b6941&"
import script from "./BordereauxDocuments.vue?vue&type=script&lang=js&"
export * from "./BordereauxDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports